

import Vue from 'vue'
import "babel-polyfill";
import promise from 'es6-promise';
import Vuex from 'vuex'
import router from './router'
import { store } from './store/store'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/style/reset.css'
import './assets/style/style.css'
import myEcharts from './assets/public/myEcharts.js'
import wx from 'weixin-js-sdk';
import utile from './assets/public/utile.js';
import api from './assets/api/controllerApi.js';
import clipboard from 'clipboard';
import url from './assets/api/url.js';
import htmlToPdf from "./utils/htmlToPdf.js"
import App from './App'
import less from 'less'
import qs from 'qs';
promise.polyfill();


// 注册Container组件
// import Container from '@/components/Container';

Vue.config.productionTip = false
Vue.prototype.clipboard = clipboard;
Vue.prototype.$wx = wx
Vue.prototype.$utile = utile
Vue.prototype.$api = api
Vue.prototype.$url = url
    // Vue.prototype.$pic = '/api' //上传图片地址
Vue.prototype.$pic = '' //上传图片地址
Vue.prototype.$qs = qs

Vue.use(Vuex)
Vue.use(Element)
Vue.use(myEcharts)
Vue.use(htmlToPdf)
Vue.use(less)
/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    render: h => h(App)
})


// WEBPACK FOOTER //
// ./src/main.js